/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    DEFAULT_SLS_ENDPOINTS_SERVICE_BASE_URL,
    SLS_SERVICE_BASE_URL_STAGING,
    SLS_SERVICE_BASE_URL_USQE1,
} from '../../config';
import { Log } from '../logging/Log';
import { MessageService } from './MessageService';

export class OverrideFeatures {
    private TAG: string = 'OverrideFeatures';

    private oOverrideFeatures: { [key: string]: any } = {};

    private GET_OVERRIDE_FEATURES: string = 'KaveriApp.BackdoorEntry.getOverriddenFeatures';

    private slsEndpoints: { [key: string]: string } = {
        qe: SLS_SERVICE_BASE_URL_USQE1,
        staging: SLS_SERVICE_BASE_URL_STAGING,
        production: DEFAULT_SLS_ENDPOINTS_SERVICE_BASE_URL,
    };

    initialize = async () => {
        return new Promise((resolve, reject) => {
            new MessageService(this.GET_OVERRIDE_FEATURES)
                .getResponse()
                .then((response) => {
                    this.oOverrideFeatures = <JSON>response;
                    resolve(true);
                })
                .catch((error) => {
                    Log.e(this.TAG, 'Failed to initialize Override Features', error);
                    reject(error);
                });
        });
    };

    public getOverriddenSlsBaseUrl = (): string => {
        const overriddenSlsEndpoint = this.oOverrideFeatures?.slsServiceEndpoint;
        const overriddenSlsEnv = this.oOverrideFeatures?.slsEnvironment;
        return overriddenSlsEndpoint || this.slsEndpoints[overriddenSlsEnv] || '';
    };
}
